//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import truncate from 'lodash/truncate';
import IconView from "@/components/objects/IconView.vue";
import { AttrsListItem } from "@/utils/dto/objects.js";
import { BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import { adjustColorBrightness, buildMaskStyle } from "@/utils/helpers.js";
import TheMaskIcon from '@/components/objects/TheMaskIcon.vue';

export default {
  name: "IconWithDetailToTop",
  components: { IconView, TheMaskIcon },
  props: {
    item: {
      type: [Object, AttrsListItem],
      default: () => {
        return {
          id: "",
          label: "",
          text: ""
        }
      }
    },
    objectId: {
      type: String,
      default: ''
    },
    direction: {
      type: String,
      default: ''
    },
    iconBorderColor: {
      type: String
    },
    bgColor: {
      type: String
    },
    bgGradientEnabled: {
      type: Boolean,
    },
    bgGradientDirection: {
      type: String
    },
    bgGradientShadowDirection: {
      type: String
    },
    iconBgColor: {
      type: String
    },
    iconColor: {
      type: String
    },
    mask: {
      type: String
    },
    textColor: {
      type: [String, null],
      default: null
    },
    detail: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    },
    expandId: {
      type: String,
      default: ''
    },
    useStorage: {
      type: Boolean,
      default: false
    },
    changeDesignToggle: {
      type: Boolean
    },
  },
  data() {
    return {
      textClamp: true,
      latestWindowWidth: 280,
      colors: ['#dfb63e', '#66a664', '#eb7608', '#7c96b7'],
      isSmallDisplay: false,
      widthBlock: {
        width: '100%',
      },
      resizeRafId: null,
      pendingResizeForce: false
    }
  },
  computed: {
    highlight() {
      return this.$route.hash === `#${this.item.id}`
    },
    isIndexOdd() {
      return this.index % 2 == 1
    },
    isIndexEven() {
      return this.index % 2 == 0
    },
    imagePath() {
      if (this.useStorage) {
        return BUILD_STORAGE_IMAGE_PATH(this.item.image_file)
      } else {
        return `/public/object_attrs_files/${this.objectId}/${this.item.id}/`
      }
    },
    currentText() {
      return this.expand || this.detail ? this.item.fullText : this.customTruncate(this.item.shortText, 130) //|| this.isSmallDisplay
    },
    itemLabel() {
      return this.item.label
    },
    isShowButtonExpand() {
      return (this.textClamp || this.expand) && !(this.item.fullText == this.customTruncate(this.item.shortText, 130))
    },
    expand() {
      return this.item.id === this.expandId
    },
    getBg() {
      if (this.bgGradientEnabled && this.bgColor) {
        return `linear-gradient(to ${this.reverseGradientDirection(this.bgGradientDirection)}, ${this.bgGradientShadowDirection === 'transparent' ? `${this.bgColor}, transparent` : `${this.bgColor}, ${adjustColorBrightness((this.bgColor), 1.20)}`})`
      } else if (this.bgColor) {
        return this.bgColor;
      }

      return null;
    },
  },
  watch: {
    detail() {
      this.$nextTick(() => {
        this.scheduleResize()
      })
    },
    changeDesignToggle() {
      let timer;
      timer = setTimeout(() => {
        this.scheduleResize(true)

        timer = clearTimeout(timer);
      }, 600);
    },
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize, { passive: true })

    this.$nextTick(() => this.scheduleResize())
  },
  destroyed() {
    window.removeEventListener('resize', this.onWindowResize)
    if (this.resizeRafId) cancelAnimationFrame(this.resizeRafId)
  },
  methods: {
    maskStyle(mask) {
      return buildMaskStyle(mask)
    },
    onWindowResize() {
      this.scheduleResize(false)
    },
    scheduleResize(force = false) {
      if (force) this._pendingResizeForce = true
      if (this.resizeRafId != null) return
      this.resizeRafId = requestAnimationFrame(() => {
        const useForce = this._pendingResizeForce || force
        this.resizeRafId = null
        this._pendingResizeForce = false
        this.resizeHandler(useForce)
      })
    },
    reverseGradientDirection(direction) {
      switch (direction) {
      case 'top':
        return 'bottom';
      case 'bottom':
        return 'top';
      case 'left':
        return 'right';
      case 'right':
        return 'left';
      }
    },
    customTruncate(text, maxLength = 200) {
      if (text.length <= maxLength) {
        return text;
      }
      return truncate(text, {
        length: maxLength,
        omission: '...',
        separator: ' '
      });
    },
    resizeHandler(force = false) {
      if (this.latestWindowWidth === window.innerWidth && !force) return

      try {
        this.latestWindowWidth = window.innerWidth
        this.$emit('expand', '')
        this.isSmallDisplay = this.latestWindowWidth <= 640

        const ITEM_BOX = this.$refs['item'].parentNode

        if (ITEM_BOX) {
          const ITEM_BOX_WIDTH = ITEM_BOX.clientWidth
          const IMAGE_WIDTH = Math.round(ITEM_BOX_WIDTH * (this.isSmallDisplay ? 0.37 : 0.30))
          this.$emit('attrs-first-width', IMAGE_WIDTH)

          this.$refs['item-image'].style.setProperty('width', `${IMAGE_WIDTH}px`)

          // const IMAGE_HEIGHT = IMAGE_WIDTH + 15

          if (!this.detail) {
            const ITEMS = ITEM_BOX.querySelectorAll('.item')

            ITEMS.forEach(el => {
              el.style.removeProperty('height')
              el.style.removeProperty('min-height')
            })

            let max_item_height = 0
            ITEMS.forEach(el => {
              const naturalHeight = el.clientHeight
              if (naturalHeight > max_item_height) {
                max_item_height = naturalHeight
              }
            })

            const targetHeight = max_item_height - 10
            ITEMS.forEach(el => {
              el.style.setProperty('height', `${targetHeight}px`)
              el.style.setProperty('min-height', `${targetHeight < 120 ? 120 : targetHeight}px`)
            })
          }

          let width = this.isSmallDisplay ? '100%' : Math.round(ITEM_BOX_WIDTH / 2 + (IMAGE_WIDTH / 2)) + 'px';
          this.widthBlock = {
            width: `${width}`,
          };
        }

        const STYLE_BOX = getComputedStyle(this.$refs['text-box'])
        const STYLE_BOX_HEIGHT = Math.floor(this.$refs['text-box'].clientHeight - (parseFloat(STYLE_BOX.paddingBottom) + parseFloat(STYLE_BOX.paddingTop)))
        const REAL_HEIGHT_FOR_TEXT = Math.floor(STYLE_BOX_HEIGHT - (this.$refs.title.clientHeight + this.$refs['expand_block'].clientHeight))

        let line_clamp = Math.floor(REAL_HEIGHT_FOR_TEXT / parseFloat(getComputedStyle(this.$refs.text).lineHeight))
        line_clamp = (this.latestWindowWidth < 640 && line_clamp > 6)
          ? 6
          : ((this.latestWindowWidth >= 640 && line_clamp >= 8) ? line_clamp - 1 : line_clamp)

        this.$refs['text-box'].style.setProperty(
          '--line-clamp',
          line_clamp
        )

        let boxHeight = this.$refs['text-box'].clientHeight

        if (this.detail) boxHeight = this.$refs['item'].clientHeight

        this.$refs['text-box'].style.setProperty('--box-height', `${boxHeight}px`)
        this.textClamp = Boolean(this.$refs.text.scrollHeight > REAL_HEIGHT_FOR_TEXT || this.currentText.length < this.item.fullText.length)
        // this.isSmallDisplay = this.latestWindowWidth <= 1439
      }
      catch (e) {

      }
    },
    handleSelfExpand() {
      if (!this.textClamp || this.detail) return

      if (this.expand) {
        this.$emit('expand', '')
      } else {
        this.$emit('expand', this.item.id)
      }
    },
  }
}
